import { render, staticRenderFns } from "./BurningMatterSummary.vue?vue&type=template&id=18ae0ec3&"
import script from "./BurningMatterSummary.vue?vue&type=script&lang=js&"
export * from "./BurningMatterSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports